import * as CookieConsent from 'vanilla-cookieconsent';
// IMPORT DLA EFEKTU UBOCZNEGO => BIBLIOTEKA USTAWIA window.initCookieConsent.
// Import wyżej TS usuwa (używany tylko jako typ), a baner startuje w onClientEntry, zanim załaduje się helmet-data.
import 'vanilla-cookieconsent';
import {handleUpdateGA4Consent,trackPageview} from "./google-analytics-service";
import * as attribution from "./attribution-service";

/** INSTANCJA BANERA => POTRZEBNA DO OTWIERANIA USTAWIEŃ Z ODNOŚNIKA „PREFERENCJE PLIKÓW COOKIES” */
let cookieConsentInstance: CookieConsent | null = null;

/** CZY ZGODA NA ANALITYKĘ BYŁA JUŻ ZASTOSOWANA => ŻEBY ROZPOZNAĆ, ŻE ZGODĘ WŁAŚNIE WYRAŻONO */
let analyticsConsentApplied: boolean = false;

/** KONFIGURACJA COOKIES */
function getCookieConsentConfig(): UserConfig {
    return {
        current_lang: 'pl',
        autoclear_cookies: true,
        cookie_domain: 'fakturomania.pl',
        cookie_name: 'fakturomania_cookie_consent',
        cookie_expiration: 180,
        cookie_same_site: 'Strict',
        // WARTOŚĆ PRZEZ encodeURIComponent (RFC 6265) => SUROWY JSON ŁAMAŁ NAGŁÓWEK Cookie W BACKENDZIE (spray)
        // ⚠️ CIASTECZKO WSPÓLNE Z APLIKACJĄ (fakturomania-react, cookie-consent.ts) => OBA BANERY MUSZĄ MIEĆ TĘ SAMĄ WARTOŚĆ,
        // INACZEJ KAŻDY run() PRZEPISUJE ZGODĘ NA SWÓJ FORMAT I BŁĄD WRACA
        use_rfc_cookie: true,
        // ZMIANA KATEGORII (fm_session przeniesione z niezbędnych do analitycznych, FAK-28914)
        // => PODBIJAMY REWIZJĘ, ŻEBY BANER POKAZAŁ SIĘ PONOWNIE (§ 3 ust. 6 Polityki cookies)
        revision: 1,
        page_scripts: true,
        gui_options: {
            consent_modal: {
                layout: 'box',
                position: 'bottom right',
                transition: 'slide'
            },
            settings_modal: {
                layout: 'box',
                transition: 'slide'
            }
        },
        // PIERWSZA DECYZJA W BANERZE => onRouteUpdate JUŻ MINĄŁ, WIĘC BIEŻĄCĄ STRONĘ TRZEBA ZLICZYĆ TERAZ
        onFirstAction: (userPreferences, cookie) => {
            handleUpdateCookieConsent(cookie.categories, true);
        },
        // WOŁANE TEŻ PRZY KAŻDYM WEJŚCIU, JEŚLI ZGODA JEST JUŻ ZAPISANA (PRZED onRouteUpdate, KTÓRY SAM ZLICZY STRONĘ)
        onAccept: (savedCookieContent) => {
            handleUpdateCookieConsent(savedCookieContent.categories, false);
        },
        onChange: (cookie, changedCookieCategories) => {
            handleUpdateCookieConsent(cookie.categories, true);
        },
        languages: {
            'pl': {
                consent_modal: {
                    title: ' Używamy plików cookie! ',
                    description: 'Witaj! Ta strona korzysta z niezbędnych plików cookie, aby zapewnić jej prawidłowe działanie. Dodatkowo używamy plików cookie śledzących, aby lepiej zrozumieć, jak z niej korzystasz. Te ostatnie zostaną zapisane tylko za Twoją zgodą. <button type="button" data-cc="c-settings" class="cc-link">Dostosuj ustawienia</button>',
                    primary_btn: {
                        text: 'Zaakceptuj wszystkie',
                        role: 'accept_all'
                    },
                    secondary_btn: {
                        text: 'Tylko niezbędne',
                        role: 'accept_necessary'
                    }
                },
                settings_modal: {
                    title: 'Fakturomania.pl - Polityka plików cookie',
                    save_settings_btn: 'Zapisz ustawienia',
                    accept_all_btn: 'Zaakceptuj wszystkie',
                    reject_all_btn: 'Odrzuć wszystkie',
                    close_btn_label: 'Zamknij',
                    cookie_table_headers: [
                        { col1: 'Nazwa' },
                        { col2: 'Domena' },
                        { col3: 'Czas przechowywania' },
                        { col4: 'Opis' }
                    ],
                    blocks: [
                        {
                            title: 'Wykorzystanie plików cookie 📢',
                            description: 'Pliki cookie są używane do zapewnienia podstawowej funkcjonalności strony oraz do poprawy Twojego doświadczenia. Możesz zarządzać zgodą dla każdej kategorii. Szczegółowe informacje znajdziesz w <a href="https://fakturomania.pl/cookies" target="_blank" class="cc-link">Polityce cookies</a>.'
                        }, {
                            title: 'Niezbędne pliki cookie',
                            description: 'Te pliki cookie są wymagane do prawidłowego działania strony i nie można ich wyłączyć.',
                            toggle: {
                                value: 'necessary',
                                enabled: true,
                                readonly: true
                            },
                            // T7 (FAK-28915): tabela w banerze to wykaz plików, do którego odsyła Polityka cookies (§ 4 ust. 6)
                            cookie_table: [
                                // ZAPAMIĘTANY WYBÓR Z BANERA (Polityka cookies § 3 ust. 6)
                                {
                                    col1: 'fakturomania_cookie_consent',
                                    col2: 'fakturomania.pl',
                                    col3: '180 dni',
                                    col4: '[Fakturomania] - Zapamiętuje wybór dokonany w banerze cookies.',
                                },
                                {
                                    col1: 'fm_attribution_consent',
                                    col2: 'fakturomania.pl (pamięć lokalna)',
                                    col3: 'Do usunięcia',
                                    col4: '[Fakturomania] - Zapamiętuje wybór dokonany w banerze cookies na potrzeby skryptu źródła wejść.',
                                },
                                // FRESHDESK => CZAT I CENTRUM POMOCY SĄ NIEZBĘDNE (Polityka cookies § 4 ust. 1 pkt 1)
                                {
                                    col1: '_fw_crm_v',
                                    col2: 'pomoc.fakturomania.pl',
                                    col3: '1 rok',
                                    col4: '[Freshchat/Freshworks] - Plik cookie (używany do śledzenia tożsamości odwiedzającego/użytkownika i sesji czatu prowadzonych przez użytkownika).',
                                },
                                {
                                    col1: '_x_w',
                                    col2: 'pomoc.fakturomania.pl',
                                    col3: 'Sesja',
                                    col4: '[Freshchat/Freshworks] - Zawiera identyfikator fragmentu, na którym działa konto.',
                                },
                                {
                                    col1: '_x_m',
                                    col2: 'pomoc.fakturomania.pl',
                                    col3: 'Sesja',
                                    col4: '[Freshchat/Freshworks] - Zawiera stan fragmentu.',
                                },
                                {
                                    col1: '_helpkit_session',
                                    col2: 'pomoc.fakturomania.pl',
                                    col3: 'Sesja',
                                    col4: '[Freshchat/Freshworks] - Twój tajny klucz do weryfikacji integralności danych sesji plików cookie. Jeśli zmienisz ten klucz, wszystkie stare sesje stracą ważność!',
                                },
                                {
                                    col1: 'helpdesk_node_session',
                                    col2: 'pomoc.fakturomania.pl',
                                    col3: 'Sesja',
                                    col4: '[Freshchat/Freshworks] - Zaszyfrowany hash przechowujący tajny klucz i identyfikator próby logowania.',
                                },
                                {
                                    col1: 'user_credentials',
                                    col2: 'pomoc.fakturomania.pl',
                                    col3: '2 miesiące',
                                    col4: '[Freshchat/Freshworks] - Używany do uwierzytelniania użytkownika.',
                                },
                                {
                                    col1: 'wf_order',
                                    col2: 'pomoc.fakturomania.pl',
                                    col3: 'Sesja',
                                    col4: '[Freshchat/Freshworks] - Służy do sprawdzenia, w jakiej kolejności zgłoszenia są filtrowane dla niestandardowych filtrów zgłoszeń, np.: termin, odpowiedź konsultanta o, odpowiedź zgłaszającego o, itp.',
                                },
                                {
                                    col1: 'wf_order_type',
                                    col2: 'pomoc.fakturomania.pl',
                                    col3: 'Sesja',
                                    col4: '[Freshchat/Freshworks] - Służy do sprawdzania, czy kolejność jest rosnąca, czy malejąca dla niestandardowych filtrów zgłoszeń.',
                                },
                                {
                                    col1: 'wf_filter',
                                    col2: 'pomoc.fakturomania.pl',
                                    col3: 'Sesja',
                                    col4: '[Freshchat/Freshworks] - Wskazuje, który filtr jest stosowany do listy zgłoszeń.',
                                },
                                {
                                    col1: '__cf_bm',
                                    col2: 'pomoc.fakturomania.pl',
                                    col3: 'Sesja',
                                    col4: '[Freshchat/Freshworks] - Ciasteczko od Cloudflare jest używane do identyfikacji i ograniczenia ruchu automatycznego, co ma na celu ochronę Twojej strony przed szkodliwymi botami. Ciasteczko to pomaga w rozróżnianiu ludzkich użytkowników od botów, co jest kluczowe dla bezpieczeństwa i wydajności witryny, zapobiegając nadużyciom i atakom.',
                                }
                            ]
                        }, {
                            title: 'Analityczne pliki cookie',
                            description: 'Pliki te pomagają w analizowaniu, jak użytkownicy korzystają ze strony.',
                            toggle: {
                                value: 'analytics',
                                enabled: true,
                                readonly: false
                            },
                            cookie_table: [
                                // === ATTRIBUTION COOKIE ===
                                // fm_session jest analityczne, nie niezbędne (FAK-28914, T3): zapisujemy je
                                // i wysyłamy touche do n8n dopiero po zgodzie na 'analytics'.
                                // Wpis w tabeli = autoclear usuwa je po wycofaniu zgody.
                                {
                                    col1: 'fm_session',
                                    col2: '.fakturomania.pl',
                                    col3: '180 dni',
                                    col4: '[Fakturomania] - Identyfikator wizyty. Pozwala łączyć wizyty w jedną ścieżkę (np. od reklamy do rejestracji) i ustalić, z jakiego źródła trafiłeś do Serwisu. Po rejestracji lub zalogowaniu może zostać przypisany do Konta.',
                                },
                                // GOOGLE ANALYTICS 4 => gtag zapisuje je we własnej domenie Serwisu (nie google.com), _gid GA4 nie używa
                                {
                                    col1: '_ga',
                                    col2: '.fakturomania.pl',
                                    col3: '2 lata',
                                    col4: '[Google Analytics] - Rozróżnia użytkowników na potrzeby statystyk korzystania z Serwisu.',
                                },
                                {
                                    col1: '_ga_XK3JNR74PF',
                                    col2: '.fakturomania.pl',
                                    col3: '2 lata',
                                    col4: '[Google Analytics] - Przechowuje stan sesji na potrzeby statystyk korzystania z Serwisu.',
                                }
                            ]
                        }, {
                            title: 'Reklamowe i marketingowe pliki cookie',
                            description: 'Pliki cookie śledzące pozwalają dostosować reklamy do Twoich preferencji.',
                            toggle: {
                                value: 'targeting',
                                enabled: true,
                                readonly: false
                            },
                            cookie_table: [
                                // GOOGLE ADS => wpis potrzebny, żeby autoclear usuwał je przy braku zgody
                                {
                                    col1: '_gcl_au',
                                    col2: '.fakturomania.pl',
                                    col3: '90 dni',
                                    col4: '[Google Ads] - Służy do pomiaru skuteczności reklam Fakturomanii (konwersji).',
                                },
                                // PAMIĘĆ LOKALNA => autoclear jej nie czyści, usuwa ją handleUpdateCookieConsent (T4)
                                {
                                    col1: '_gcl_ls',
                                    col2: 'fakturomania.pl (pamięć lokalna)',
                                    col3: 'Do usunięcia',
                                    col4: '[Google Ads] - Zapisuje informację o kliknięciu w reklamę Fakturomanii.',
                                },
                                {
                                    col1: 'hp2_id',
                                    col2: 'freshworks.com',
                                    col3: '2 lata',
                                    col4: '[Freshchat/Freshworks] - Ciasteczka te mogą być umieszczane na naszej stronie przez naszych partnerów reklamowych. Służą do tworzenia profilu Twoich zainteresowań i wyświetlania odpowiednich reklam na innych stronach. Nie przechowują bezpośrednio informacji osobistych, ale opierają się na unikalnym identyfikowaniu Twojej przeglądarki i urządzenia internetowego. Jeśli ich nie zaakceptujesz, będziesz otrzymywać mniej spersonalizowane reklamy.'
                                }
                            ]
                        }
                    ]
                }
            }
        }
    } as UserConfig;
}

/**
 * Uruchamia baner RAZ, przy wejściu na stronę (gatsby-browser.js => onClientEntry).
 * Jeśli zgoda jest już zapisana, biblioteka od razu woła onAccept => GA i attribution startują przed onRouteUpdate.
 * Jeśli nie ma zgody, pokazuje baner, a GA i attribution czekają na decyzję.
 */
export function handleInitializeCookieConsent() {
    // JUŻ URUCHOMIONY => NIC NIE ROBIMY
    if (cookieConsentInstance) return;

    console.log("Initializing Cookie Consent");
    cookieConsentInstance = window.initCookieConsent();
    cookieConsentInstance.run(getCookieConsentConfig());

    // BRAK WAŻNEJ ZGODY (PIERWSZA WIZYTA, WYGASŁA ALBO NOWA REWIZJA)
    // => CZYŚCIMY ZGODY ZAPAMIĘTANE PRZEZ ATTRIBUTION, ŻEBY NIE WYSŁAĆ TOUCHA PRZED DECYZJĄ W BANERZE
    if (!cookieConsentInstance.validConsent()) {
        attribution.handleUpdateAttributionConsent(false, false);
    }
}

/** OTWIERA USTAWIENIA BANERA => ODNOŚNIK „PREFERENCJE PLIKÓW COOKIES” W STOPCE */
export function showCookieSettings() {
    if (!cookieConsentInstance) {
        handleInitializeCookieConsent();
    }
    cookieConsentInstance.showSettings(0);
}

function handleUpdateCookieConsent(allowedCategories: string[], trackCurrentPage: boolean) {
    // DANE UNIWERSALNE
    // Sprawdzamy czy w tablicy zaakceptowanych kategorii jest 'analytics' (>-1 oznacza "znalezione")
    const analyticsGranted: boolean = allowedCategories.indexOf('analytics') > -1;
    // Analogicznie dla 'targeting' (czyli marketing/advertising)
    const advertisingGranted: boolean = allowedCategories.indexOf('targeting') > -1;
    // Powiadom GA4 o zmianie zgód — Google Tag Manager dostaje "consent update" event
    handleUpdateGA4Consent(analyticsGranted,advertisingGranted);

    // === ATTRIBUTION ===
    // Powiadom też nasz attribution-service o nowych zgodach.
    // Wewnętrznie zapisuje stan w localStorage i emit-uje świeży touch
    // żeby backend dostał update zgód (i mógł wzbogacić analitykę).
    attribution.handleUpdateAttributionConsent(analyticsGranted, advertisingGranted);

    // ZGODA NA ANALITYKĘ WYRAŻONA W TRAKCIE WIZYTY => ZLICZAMY BIEŻĄCĄ STRONĘ (GA4 + TOUCH DO n8n)
    const analyticsJustGranted: boolean = analyticsGranted && !analyticsConsentApplied;
    analyticsConsentApplied = analyticsGranted;
    if (trackCurrentPage && analyticsJustGranted) {
        trackPageview(window.location.pathname);
        attribution.touch(window.location.pathname);
    }

    // === PAMIĘĆ LOKALNA (T4, FAK-28915) ===
    // autoclear_cookies czyści tylko cookies z tabel => klucze localStorage usuwamy sami (Polityka cookies § 3 ust. 5)
    if (!advertisingGranted) {
        removeLocalStorageKeys(MARKETING_LOCAL_STORAGE_KEYS);
    }
}

/** KLUCZE PAMIĘCI LOKALNEJ Z KATEGORII MARKETINGOWEJ => MUSZĄ ZGADZAĆ SIĘ Z TABELĄ W BANERZE */
const MARKETING_LOCAL_STORAGE_KEYS: string[] = ['_gcl_ls'];

function removeLocalStorageKeys(keys: string[]) {
    // try/catch bo localStorage może rzucić wyjątkiem (np. zablokowane dane witryny)
    try {
        keys.forEach((key: string) => localStorage.removeItem(key));
    } catch (e) {
        // Fail silent — nie blokujemy strony
    }
}


// WEBPACK FOOTER //
// ./src/services/cookie-consent-service.ts